// extracted by mini-css-extract-plugin
export default {"faq":"Faq_faq__HLunZ","faqTitle":"Faq_faqTitle__GXVET","faqElem":"Faq_faqElem__zqJfl","text":"Faq_text__YBfoG","answerImage":"Faq_answerImage__pE-dc"};